const cartComponent = document.getElementsByClassName('cart-container')[0];

if (cartComponent) {
  // console.log(cartComponent);
  const cartOpenBtn = cartComponent.querySelector('.cart-open');
  const cartMobileOpenBtn = document.querySelector('.cart-open-mob');
  const cartMoreOpenBtn = document.querySelector('.cart__list-more');
  const cartCloseBg = cartComponent.querySelector('.cart-close-wrapper');
  const cartCloseMobBtn = cartComponent.querySelector('.cart__close');
  const cart = cartComponent.querySelector('.cart');

  const cartTitle = cartComponent.querySelector('.cart__title');
  const cartList = cartComponent.querySelector('.cart__list');
  const cartVisibleBottom = cartComponent.querySelector(
    '.cart__visible-bottom'
  );
  const cartResult = cartComponent.querySelector('.cart__result');

  let scrollList = null;

  let openDelay = 500;

  function openCartFunc() {
    if (!cartComponent.classList.contains('is-open')) {
      const productsArr = cartList.querySelectorAll('.cart__item');
      for (let i = 0; i < productsArr.length; i++) {
        productsArr[i].classList.remove('hidden');
      }
      cartComponent.classList.add('is-open');
      cartComponent.style.zIndex = 1000;
      scrollListCalc();
    } else {
      cartComponent.classList.remove('is-open');

      setTimeout(function () {
        cartComponent.style.zIndex = 800;
      }, openDelay);
      /*disableScrollListFunc();*/
      scrollListCalc();
      moreCounterFunc();
    }

    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (
      !document
        .getElementsByClassName('header')[0]
        .classList.contains('open-menu')
    ) {
      if (scrollLock.getScrollState()) {
        scrollLock.disablePageScroll(
          document.querySelector('.navbar-nav .menu')
        );
        scrollLock.addScrollableSelector('.simplebar-content-wrapper');
      } else {
        scrollLock.enablePageScroll();
      }
    }
  }

  cartOpenBtn.addEventListener('click', () => {
    openCartFunc();
  });

  cartMobileOpenBtn.addEventListener('click', () => {
    openCartFunc();
  });

  cartCloseBg.addEventListener('click', () => {
    openCartFunc();
  });

  cartCloseMobBtn.addEventListener('click', () => {
    openCartFunc();
  });

  cartMoreOpenBtn.addEventListener('click', () => {
    openCartFunc();
  });

  function scrollListCalc() {
    if (cartList && cartComponent.classList.contains('is-open')) {
      cartList.style.maxHeight = `calc(100% - ${
        cartTitle.clientHeight + cartResult.clientHeight
      }px)`;
    } else if (cartList && !cartComponent.classList.contains('is-open')) {
      cartList.style.maxHeight = `calc(100% - ${
        cartTitle.clientHeight + cartVisibleBottom.clientHeight
      }px)`;
    }
  }
  scrollListCalc();

  function enableScrollListFunc() {
    if (cartList) {
      scrollList = new SimpleBar(cartList);
    }
  }
  enableScrollListFunc();

  function disableScrollListFunc() {
    if (cartList) {
      scrollList.unMount();
    }
  }

  window.moreCounterFunc = function moreCounterFunc() {
    const cartListMoreShowEl = cartMoreOpenBtn.querySelector(
      '.cart__list-more-text.with-show'
    );
    const cartListMoreNotShowEl = cartMoreOpenBtn.querySelector(
      '.cart__list-more-text.with-not-show'
    );
    const cartListMoreCounter = cartListMoreShowEl.querySelector('span');
    const productsArr = cartList.querySelectorAll('.cart__item');
    const productCount = productsArr.length;
    const productMenuCounter = document.querySelector(
      'header .small-btn-icon__count'
    );

    if (productMenuCounter) {
      let previousCheckoutValue = 0;

      const checkAndUpdate = () => {
        let totalCheckoutValue = 0;

        productsArr.forEach((productEl) => {
          const checkoutInput = productEl.querySelector('.checkout-input');
          if (checkoutInput) {
            const value = parseFloat(checkoutInput.value) || 0;
            totalCheckoutValue += value;
          }
        });

        if (totalCheckoutValue !== previousCheckoutValue) {
          /*console.log('checkoutInput:', totalCheckoutValue);*/
          previousCheckoutValue = totalCheckoutValue;

          productMenuCounter.textContent = `${totalCheckoutValue}`;
        }
      };

      checkAndUpdate();
      setInterval(checkAndUpdate, 1000);

      if (productCount >= 1) {
        productMenuCounter.classList.remove('is-hidden');
      } else {
        productMenuCounter.classList.add('is-hidden');
      }
    }

    if (!cartComponent.classList.contains('is-open') && productCount > 0) {
      /*console.log(productCount);*/

      productsArr.forEach((item) => item.classList.remove('hidden'));

      let threshold = window.innerHeight > 800 ? 3 : 2;

      if (productCount > threshold) {
        cartListMoreCounter.textContent = `${productCount - threshold}`;

        for (let i = threshold; i < productsArr.length; i++) {
          productsArr[i].classList.add('hidden');
        }

        cartListMoreShowEl.classList.remove('hidden');
        cartListMoreNotShowEl.classList.add('hidden');
      } else {
        cartListMoreCounter.textContent = '0';
        cartListMoreShowEl.classList.add('hidden');
        cartListMoreNotShowEl.classList.remove('hidden');
      }
    }

    scrollListCalc();
  };

  moreCounterFunc();

  window.addEventListener('resize', scrollListCalc);
}

window.closeCartGlobal = function closeCartGlobal() {
  if (cartComponent) {
    cartComponent.classList.remove('is-open');
    moreCounterFunc();

    setTimeout(function () {
      cartComponent.style.zIndex = 800;
    }, 500);
  }
};

window.checkoutCartItems = function checkoutCartItems() {
  const checkoutBtn = document.querySelector(
    '.cart-container .cart-checkout-btn'
  );
  const checkoutListItemArr = document.querySelectorAll(
    '.cart-container .cart__item'
  );
  const notProductsContent = document.querySelector(
    '.cart-container .cart__not-products-container'
  );

  if (document.querySelector('.cart-container')) {
    if (checkoutListItemArr.length >= 1) {
      notProductsContent.classList.remove('is-visible');
      moreCounterFunc();
    } else {
      notProductsContent.classList.add('is-visible');
    }
  }

  updateCardsFunc();
};

window.updateCardsFunc = function updateCardsFunc() {
  if (document.querySelector('.cart__list')) {
    const cards = document.querySelectorAll('.product-card');
    cards.forEach((card) => {
      if (card.classList.contains('is-open-counter')) {
        const input = card.querySelector('.checkout-input');
        const btnCounter = card.querySelector('.product-card__btn-counter');
        if ((input && input.value < 1) || (input && input.value === '')) {
          card.classList.remove('is-open-counter');

          if (btnCounter) {
            btnCounter.classList.remove('active');
          }
        }
      }
    });
  }
};

/*setTimeout(function () {
  checkoutCartItems();
}, 1000);*/
